//APP
export const SET_THEME                                        = "SET_THEME";
export const SET_LANG                                         = "SET_LANG";
export const SET_TAB                                          = "SET_TAB";
export const SET_ROLE                                         = "SET_ROLE";
export const SET_OPEN_SNACK                                   = "SET_OPEN_SNACK";
export const SET_CLOSE_SNACK                                  = "SET_CLOSE_SNACK";
export const GET_EVENTS_START                                 = "GET_EVENTS_START";
export const GET_EVENTS_SUCCESS                               = "GET_EVENTS_SUCCESS";
export const GET_EVENTS_FAIL                                  = "GET_EVENTS_FAIL";
export const GENERATE_EVENT_START                             = "GENERATE_EVENT_START";
export const GENERATE_EVENT_SUCCESS                           = "GENERATE_EVENT_SUCCESS";
export const GENERATE_EVENT_FAIL                              = "GENERATE_EVENT_FAIL";

//NOTIFICATION
export const GET_MESSAGE_START                                = "GET_MESSAGE_START";
export const GET_MESSAGE_SUCCESS                              = "GET_MESSAGE_SUCCESS";
export const GET_MESSAGE_FAIL                                 = "GET_MESSAGE_FAIL";
export const ADD_EMAIL_START                                  = "ADD_EMAIL_START";
export const ADD_EMAIL_SUCCESS                                = "ADD_EMAIL_SUCCESS";
export const ADD_EMAIL_FAIL                                   = "ADD_EMAIL_FAIL";

//AUTH
export const AUTH_START                                       = "AUTH_START";
export const AUTH_SUCCESS                                     = "AUTH_SUCCESS";
export const AUTH_FAIL                                        = "AUTH_FAIL";
export const REGIST_START                                     = "REGIST_START";
export const REGIST_SUCCESS                                   = "REGIST_SUCCESS";
export const REGIST_FAIL                                      = "REGIST_FAIL";
export const CHANGE_PASSWORD_START                            = "CHANGE_PASSWORD_START";
export const CHANGE_PASSWORD_SUCCESS                          = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAIL                             = "CHANGE_PASSWORD_FAIL";
export const FORGOT_PASSWORD_START                            = "FORGOT_PASSWORD_START";
export const FORGOT_PASSWORD_SUCCESS                          = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAIL                             = "FORGOT_PASSWORD_FAIL";
export const SEND_NEW_PASSWORD_START                          = "SEND_NEW_PASSWORD_START";
export const SEND_NEW_PASSWORD_SUCCESS                        = "SEND_NEW_PASSWORD_SUCCESS";
export const SEND_NEW_PASSWORD_FAIL                           = "SEND_NEW_PASSWORD_FAIL";
export const GET_ALL_USERS_START                              = "GET_ALL_USERS_START";
export const GET_ALL_USERS_SUCCESS                            = "GET_ALL_USERS_SUCCESS";
export const GET_ALL_USERS_FAIL                               = "GET_ALL_USERS_FAIL";
export const ADD_ROLE_TO_USERS_START                          = "ADD_ROLE_TO_USERS_START";
export const ADD_ROLE_TO_USERS_SUCCESS                        = "ADD_ROLE_TO_USERS_SUCCESS";
export const ADD_ROLE_TO_USERS_FAIL                           = "ADD_ROLE_TO_USERS_FAIL";
export const DELETE_ROLE_TO_USERS_START                       = "DELETE_ROLE_TO_USERS_START";
export const DELETE_ROLE_TO_USERS_SUCCESS                     = "DELETE_ROLE_TO_USERS_SUCCESS";
export const DELETE_ROLE_TO_USERS_FAIL                        = "DELETE_ROLE_TO_USERS_FAIL";
export const GET_ALL_COMPANIES_START                          = "GET_ALL_COMPANIES_START";
export const GET_ALL_COMPANIES_SUCCESS                        = "GET_ALL_COMPANIES_SUCCESS";
export const GET_ALL_COMPANIES_FAIL                           = "GET_ALL_COMPANIES_FAIL";
export const ADD_AVATAR_START                                 = "ADD_AVATAR_START";
export const ADD_AVATAR_SUCCESS                               = "ADD_AVATAR_SUCCESS";
export const ADD_AVATAR_FAIL                                  = "ADD_AVATAR_FAIL";
export const UPDATE_USER_START                                = "UPDATE_USER_START";
export const UPDATE_USER_SUCCESS                              = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAIL                                 = "UPDATE_USER_FAIL";

//TABLE
export const SET_PAGE                                         = "SET_PAGE";
export const SET_ORDER                                        = "SET_ORDER";
export const SET_ORDER_BY                                     = "SET_ORDER_BY";
export const SET_ROWS_PER_PAGE                                = "SET_ROWS_PER_PAGE";
export const SET_COUNT                                        = "SET_COUNT";

//ANAGRAFICA
export const SET_ANAGRAFICA                                   = "SET_ANAGRAFICA";
export const RESET_ANAGRAFICA                                 = "RESET_ANAGRAFICA";
export const GET_ANAGRAFICA_START                             = "GET_ANAGRAFICA_START";
export const GET_ANAGRAFICA_SUCCESS                           = "GET_ANAGRAFICA_SUCCESS";
export const GET_ANAGRAFICA_FAIL                              = "GET_ANAGRAFICA_FAIL";
export const UPDATE_ANAGRAFICA_START                          = "UPDATE_ANAGRAFICA_START";
export const UPDATE_ANAGRAFICA_SUCCESS                        = "UPDATE_ANAGRAFICA_SUCCESS";
export const UPDATE_ANAGRAFICA_FAIL                           = "UPDATE_ANAGRAFICA_FAIL";
export const SEARCH_ANAGRAFICA_START                          = "SEARCH_ANAGRAFICA_START";
export const SEARCH_ANAGRAFICA_SUCCESS                        = "SEARCH_ANAGRAFICA_SUCCESS";
export const SEARCH_ANAGRAFICA_FAIL                           = "SEARCH_ANAGRAFICA_FAIL";
export const ADD_ANAGRAFICA_START                             = "ADD_ANAGRAFICA_START";
export const ADD_ANAGRAFICA_SUCCESS                           = "ADD_ANAGRAFICA_SUCCESS";
export const ADD_ANAGRAFICA_FAIL                              = "ADD_ANAGRAFICA_FAIL";
export const GET_ANAGRAFICA_ASSOCIATA_START                   = "GET_ANAGRAFICA_ASSOCIATA_START";
export const GET_ANAGRAFICA_ASSOCIATA_SUCCESS                 = "GET_ANAGRAFICA_ASSOCIATA_SUCCESS";
export const GET_ANAGRAFICA_ASSOCIATA_FAIL                    = "GET_ANAGRAFICA_ASSOCIATA_FAIL";
export const ADD_NOTE_TO_DIARIO_START                         = "ADD_NOTE_TO_DIARIO_START";
export const ADD_NOTE_TO_DIARIO_SUCCESS                       = "ADD_NOTE_TO_DIARIO_SUCCESS";
export const ADD_NOTE_TO_DIARIO_FAIL                          = "ADD_NOTE_TO_DIARIO_FAIL";
export const GET_ALLEGATI_START                               = "ADD_ALLEGATO_START";
export const GET_ALLEGATI_SUCCESS                             = "ADD_ALLEGATO_SUCCESS";
export const GET_ALLEGATI_FAIL                                = "ADD_ALLEGATO_FAIL";

//INTERVISTA
export const GENERATE_INTERVISTA_START                        = "GENERATE_INTERVISTA_START";
export const GENERATE_INTERVISTA_SUCCESS                      = "GENERATE_INTERVISTA_SUCCESS";
export const GENERATE_INTERVISTA_FAIL                         = "GENERATE_INTERVISTA_FAIL";
export const GENERATE_INTERVISTA_CITTADINO_START              = "GENERATE_INTERVISTA_CITTADINO_START";
export const GENERATE_INTERVISTA_CITTADINO_SUCCESS            = "GENERATE_INTERVISTA_CITTADINO_SUCCESS";
export const GENERATE_INTERVISTA_CITTADINO_FAIL               = "GENERATE_INTERVISTA_CITTADINO_FAIL";
export const GENERATE_INTERVISTA_INCOMPLETA_START             = "GENERATE_INTERVISTA_INCOMPLETA_START";
export const GENERATE_INTERVISTA_INCOMPLETA_SUCCESS           = "GENERATE_INTERVISTA_INCOMPLETA_SUCCESS";
export const GENERATE_INTERVISTA_INCOMPLETA_FAIL              = "GENERATE_INTERVISTA_INCOMPLETA_FAIL";
export const SET_INTERVISTA                                   = "SET_INTERVISTA";
export const GET_INTERVISTA_START                             = "GET_INTERVISTA_START";
export const GET_INTERVISTA_SUCCESS                           = "GET_INTERVISTA_SUCCESS";
export const GET_INTERVISTA_FAIL                              = "GET_INTERVISTA_FAIL";
export const GET_INCOMPLETA_START                             = "GET_INCOMPLETA_START";
export const GET_INCOMPLETA_SUCCESS                           = "GET_INCOMPLETA_SUCCESS";
export const GET_INCOMPLETA_FAIL                              = "GET_INCOMPLETA_FAIL";
export const UPDATE_INTERVISTA_START                          = "UPDATE_INTERVISTA_START";
export const UPDATE_INTERVISTA_SUCCESS                        = "UPDATE_INTERVISTA_SUCCESS";
export const UPDATE_INTERVISTA_FAIL                           = "UPDATE_INTERVISTA_FAIL";

//CSV
export const ADD_CSV_START                                    = "ADD_CSV_START";
export const ADD_CSV_SUCCESS                                  = "ADD_CSV_SUCCESS";
export const ADD_CSV_FAIL                                     = "ADD_CSV_FAIL";
export const ADD_POSITIVI_CSV_START                           = "ADD_POSITIVI_CSV_START";
export const ADD_POSITIVI_CSV_SUCCESS                         = "ADD_POSITIVI_CSV_SUCCESS";
export const ADD_POSITIVI_CSV_FAIL                            = "ADD_POSITIVI_CSV_FAIL";
export const ADD_TAMPONI_CSV_START                            = "ADD_TAMPONI_CSV_START";
export const ADD_TAMPONI_CSV_SUCCESS                          = "ADD_TAMPONI_CSV_SUCCESS";
export const ADD_TAMPONI_CSV_FAIL                             = "ADD_TAMPONI_CSV_FAIL";
export const ADD_ANAGRAFICHE_CSV_START                        = "ADD_ANAGRAFICHE_CSV_START";
export const ADD_ANAGRAFICHE_CSV_SUCCESS                      = "ADD_ANAGRAFICHE_CSV_SUCCESS";
export const ADD_ANAGRAFICHE_CSV_FAIL                         = "ADD_ANAGRAFICHE_CSV_FAIL";
export const SEND_CSV_START                                   = "SEND_CSV_START";
export const SEND_CSV_SUCCESS                                 = "SEND_CSV_SUCCESS";
export const SEND_CSV_FAIL                                    = "SEND_CSV_FAIL";

//AUTOMATION
export const ON_CLICK_DETAILS_START                           = "ON_CLICK_DETAILS_START";
export const ON_CLICK_DETAILS_SUCCESS                         = "ON_CLICK_DETAILS_SUCCESS";
export const ON_CLICK_DETAILS_FAIL                            = "ON_CLICK_DETAILS_FAIL";

//TAMPONI
export const GET_TAMPONE_BY_ID_START                          = "GET_TAMPONE_BY_ID_START";
export const GET_TAMPONE_BY_ID_SUCCESS                        = "GET_TAMPONE_BY_ID_SUCCESS";
export const GET_TAMPONE_BY_ID_FAIL                           = "GET_TAMPONE_BY_ID_FAIL";
export const PRENOTA_TAMPONE_START                            = "PRENOTA_TAMPONE_START";
export const PRENOTA_TAMPONE_SUCCESS                          = "PRENOTA_TAMPONE_SUCCESS";
export const PRENOTA_TAMPONE_FAIL                             = "PRENOTA_TAMPONE_FAIL";
export const UPDATE_TAMPONE_START                             = "UPDATE_TAMPONE_START";
export const UPDATE_TAMPONE_SUCCESS                           = "UPDATE_TAMPONE_SUCCESS";
export const UPDATE_TAMPONE_FAIL                              = "UPDATE_TAMPONE_FAIL";
export const CREATE_TAMPONE_START                             = "CREATE_TAMPONE_START";
export const CREATE_TAMPONE_SUCCESS                           = "CREATE_TAMPONE_SUCCESS";
export const CREATE_TAMPONE_FAIL                              = "CREATE_TAMPONE_FAIL";
export const CHECK_UPLOAD_START                               = "CHECK_UPLOAD_START";
export const CHECK_UPLOAD_SUCCESS                             = "CHECK_UPLOAD_SUCCESS";
export const CHECK_UPLOAD_FAIL                                = "CHECK_UPLOAD_FAIL";
export const GET_TAMPONI_BY_MONTH_START                       = "GET_TAMPONI_BY_MONTH_START";
export const GET_TAMPONI_BY_MONTH_SUCCESS                     = "GET_TAMPONI_BY_MONTH_SUCCESS";
export const GET_TAMPONI_BY_MONTH_FAIL                        = "GET_TAMPONI_BY_MONTH_FAIL";
export const GET_TAMPONI_BY_DAY_START                         = "GET_TAMPONI_BY_DAY_START";
export const GET_TAMPONI_BY_DAY_SUCCESS                       = "GET_TAMPONI_BY_DAY_SUCCESS";
export const GET_TAMPONI_BY_DAY_FAIL                          = "GET_TAMPONI_BY_DAY_FAIL";
export const RESET_TAMPONI_DAY                                = "RESET_TAMPONI_DAY";

//PRENOTAZIONI
export const GET_PRENOTAZIONE_START                           = "GET_PRENOTAZIONE_START";
export const GET_PRENOTAZIONE_SUCCESS                         = "GET_PRENOTAZIONE_SUCCESS";
export const GET_PRENOTAZIONE_FAIL                            = "GET_PRENOTAZIONE_FAIL";
export const UPDATE_PRENOTAZIONE_START                        = "UPDATE_PRENOTAZIONE_START";
export const UPDATE_PRENOTAZIONE_SUCCESS                      = "UPDATE_PRENOTAZIONE_SUCCESS";
export const UPDATE_PRENOTAZIONE_FAIL                         = "UPDATE_PRENOTAZIONE_FAIL";
export const GET_STORICO_PRENOTAZIONE_START                   = "GET_STORICO_PRENOTAZIONE_START";
export const GET_STORICO_PRENOTAZIONE_FAIL                    = "GET_STORICO_PRENOTAZIONE_FAIL";
export const GET_STORICO_PRENOTAZIONE_SUCCESS                 = "GET_STORICO_PRENOTAZIONE_SUCCESS";
export const ADD_STORICO_PRENOTAZIONE_START                   = "ADD_STORICO_PRENOTAZIONE_START";
export const ADD_STORICO_PRENOTAZIONE_FAIL                    = "ADD_STORICO_PRENOTAZIONE_FAIL";
export const ADD_STORICO_PRENOTAZIONE_SUCCESS                 = "ADD_STORICO_PRENOTAZIONE_SUCCESS";
export const ADD_AGENDA_START                                 = "ADD_AGENDA_START";
export const ADD_AGENDA_FAIL                                  = "ADD_AGENDA_FAIL";
export const ADD_AGENDA_SUCCESS                               = "ADD_AGENDA_SUCCESS";
export const GET_ALL_AGENDE_START                             = "GET_ALL_AGENDE_START";
export const GET_ALL_AGENDE_FAIL                              = "GET_ALL_AGENDE_FAIL";
export const GET_ALL_AGENDE_SUCCESS                           = "GET_ALL_AGENDE_SUCCESS";
export const GET_INFO_PRENOTAZIONI_START                      = "GET_INFO_PRENOTAZIONI_START";
export const GET_INFO_PRENOTAZIONI_FAIL                       = "GET_INFO_PRENOTAZIONI_FAIL";
export const GET_INFO_PRENOTAZIONI_SUCCESS                    = "GET_INFO_PRENOTAZIONI_SUCCESS";
export const SEND_PDF_START                                   = "SEND_PDF_START";
export const SEND_PDF_FAIL                                    = "SEND_PDF_FAIL";
export const SEND_PDF_SUCCESS                                 = "SEND_PDF_SUCCESS";
export const SEARCH_PRENOTAZIONE_START                        = "SEARCH_PRENOTAZIONE_START";
export const SEARCH_PRENOTAZIONE_SUCCESS                      = "SEARCH_PRENOTAZIONE_SUCCESS";
export const SEARCH_PRENOTAZIONE_FAIL                         = "SEARCH_PRENOTAZIONE_FAIL";

//PAZIENTE
export const GET_DIARIO_PAZIENTE_START                        = "GET_DIARIO_PAZIENTE_START";
export const GET_DIARIO_PAZIENTE_SUCCESS                      = "GET_DIARIO_PAZIENTE_SUCCESS";
export const GET_DIARIO_PAZIENTE_FAIL                         = "GET_DIARIO_PAZIENTE_FAIL";
export const GET_RELAZIONI_START                              = "GET_RELAZIONI_START";
export const GET_RELAZIONI_SUCCESS                            = "GET_RELAZIONI_SUCCESS";
export const GET_RELAZIONI_FAIL                               = "GET_RELAZIONI_FAIL";
export const ADD_RELAZIONE_START                              = "ADD_RELAZIONE_START";
export const ADD_RELAZIONE_SUCCESS                            = "ADD_RELAZIONE_SUCCESS";
export const ADD_RELAZIONE_FAIL                               = "ADD_RELAZIONE_FAIL";
export const SET_DIARIO                                       = "SET_DIARIO";

//FOCOLAI
export const GET_FOCOLAIO_START                               = "GET_FOCOLAIO_START";
export const GET_FOCOLAIO_SUCCESS                             = "GET_FOCOLAIO_SUCCESS";
export const GET_FOCOLAIO_FAIL                                = "GET_FOCOLAIO_FAIL";
export const UPDATE_FOCOLAIO_START                            = "UPDATE_FOCOLAIO_START";
export const UPDATE_FOCOLAIO_SUCCESS                          = "UPDATE_FOCOLAIO_SUCCESS";
export const UPDATE_FOCOLAIO_FAIL                             = "UPDATE_FOCOLAIO_FAIL";
export const MODIFY_ALIAS_FOCOLAIO_START                      = "MODIFY_ALIAS_FOCOLAIO_START";
export const MODIFY_ALIAS_FOCOLAIO_SUCCESS                    = "MODIFY_ALIAS_FOCOLAIO_SUCCESS";
export const MODIFY_ALIAS_FOCOLAIO_FAIL                       = "MODIFY_ALIAS_FOCOLAIO_FAIL";

//QUARANTENE
export const GENERATE_QUARANTENA_START                        = "GENERATE_QUARANTENA_START";
export const GENERATE_QUARANTENA_SUCCESS                      = "GENERATE_QUARANTENA_SUCCESS";
export const GENERATE_QUARANTENA_FAIL                         = "GENERATE_QUARANTENA_FAIL";
export const GET_QUARANTENA_START                             = "GET_QUARANTENA_START";
export const GET_QUARANTENA_SUCCESS                           = "GET_QUARANTENA_SUCCESS";
export const GET_QUARANTENA_FAIL                              = "GET_QUARANTENA_FAIL";
export const UPDATE_QUARANTENA_START                          = "UPDATE_QUARANTENA_START";
export const UPDATE_QUARANTENA_SUCCESS                        = "UPDATE_QUARANTENA_SUCCESS";
export const UPDATE_QUARANTENA_FAIL                           = "UPDATE_QUARANTENA_FAIL";
export const ADD_QUARANTENA_HISTORY_START                     = "ADD_QUARANTENA_HISTORY_START";
export const ADD_QUARANTENA_HISTORY_SUCCESS                   = "ADD_QUARANTENA_HISTORY_SUCCESS";
export const ADD_QUARANTENA_HISTORY_FAIL                      = "ADD_QUARANTENA_HISTORY_FAIL";
export const GET_QUARANTENA_HISTORY_START                     = "GET_QUARANTENA_HISTORY_START";
export const GET_QUARANTENA_HISTORY_SUCCESS                   = "GET_QUARANTENA_HISTORY_SUCCESS";
export const GET_QUARANTENA_HISTORY_FAIL                      = "GET_QUARANTENA_HISTORY_FAIL";
export const GET_QUARANTENE_BY_MONTH_START                    = "GET_QUARANTENE_BY_MONTH_START";
export const GET_QUARANTENE_BY_MONTH_SUCCESS                  = "GET_QUARANTENE_BY_MONTH_SUCCESS";
export const GET_QUARANTENE_BY_MONTH_FAIL                     = "GET_QUARANTENE_BY_MONTH_FAIL";
export const GET_QUARANTENE_BY_DAY_START                      = "GET_QUARANTENE_BY_DAY_START";
export const GET_QUARANTENE_BY_DAY_SUCCESS                    = "GET_QUARANTENE_BY_DAY_SUCCESS";
export const GET_QUARANTENE_BY_DAY_FAIL                       = "GET_QUARANTENE_BY_DAY_FAIL";
export const GET_ALL_INFO_QUARANTENE_START                    = "GET_ALL_INFO_QUARANTENE_START";
export const GET_ALL_INFO_QUARANTENE_SUCCESS                  = "GET_ALL_INFO_QUARANTENE_SUCCESS";
export const GET_ALL_INFO_QUARANTENE_FAIL                     = "GET_ALL_INFO_QUARANTENE_FAIL";
export const RESET_GET_QUARANTENE_DAY                         = "RESET_GET_QUARANTENE_DAY";

//PROTOCOLLI
export const GET_PROTOCOLLO_START                             = "GET_PROTOCOLLO_START";
export const GET_PROTOCOLLO_SUCCESS                           = "GET_PROTOCOLLO_SUCCESS";
export const GET_PROTOCOLLO_FAIL                              = "GET_PROTOCOLLO_FAIL";
export const PROTOCOLLA_PROTOCOLLO_START                      = "PROTOCOLLA_PROTOCOLLO_START";
export const PROTOCOLLA_PROTOCOLLO_SUCCESS                    = "PROTOCOLLA_PROTOCOLLO_SUCCESS";
export const PROTOCOLLA_PROTOCOLLO_FAIL                       = "PROTOCOLLA_PROTOCOLLO_FAIL";
export const UPDATE_PROTOCOLLO_START                          = "UPDATE_PROTOCOLLO_START";
export const UPDATE_PROTOCOLLO_SUCCESS                        = "UPDATE_PROTOCOLLO_SUCCESS";
export const UPDATE_PROTOCOLLO_FAIL                           = "UPDATE_PROTOCOLLO_FAIL";
export const GET_ALL_INFO_PROTOCOLLI_START                    = "GET_ALL_INFO_PROTOCOLLI_START";
export const GET_ALL_INFO_PROTOCOLLI_SUCCESS                  = "GET_ALL_INFO_PROTOCOLLI_SUCCESS";
export const GET_ALL_INFO_PROTOCOLLI_FAIL                     = "GET_ALL_INFO_PROTOCOLLI_FAIL";

//MONITORAGGI
export const GENERATE_MONITORAGGIO_START                      = "GENERATE_MONITORAGGIO_START";
export const GENERATE_MONITORAGGIO_SUCCESS                    = "GENERATE_MONITORAGGIO_SUCCESS";
export const GENERATE_MONITORAGGIO_FAIL                       = "GENERATE_MONITORAGGIO_FAIL";
export const GET_ALL_MONITORAGGI_START                        = "GET_ALL_MONITORAGGI_START";
export const GET_ALL_MONITORAGGI_SUCCESS                      = "GET_ALL_MONITORAGGI_SUCCESS";
export const GET_ALL_MONITORAGGI_FAIL                         = "GET_ALL_MONITORAGGI_FAIL";
export const ASK_FOR_MONITORAGGIO_START                       = "ASK_FOR_MONITORAGGIO_START";
export const ASK_FOR_MONITORAGGIO_SUCCESS                     = "ASK_FOR_MONITORAGGIO_SUCCESS";
export const ASK_FOR_MONITORAGGIO_FAIL                        = "ASK_FOR_MONITORAGGIO_FAIL";

//FILTERS
export const SET_FILTERS                                      = "SET_FILTERS";
export const SET_FILTER_SEARCH_VAL                            = "SET_FILTER_SEARCH_VAL";
export const SET_ALL_SELECTED                                 = "SET_ALL_SELECTED";
export const SET_ALL_DESELECTED                               = "SET_ALL_DESELECTED";

//REFERENTE AZIENDA
export const UPDATE_COMPANY_START                             = "UPDATE_COMPANY_START";
export const UPDATE_COMPANY_SUCCESS                           = "UPDATE_COMPANY_SUCCESS";
export const UPDATE_COMPANY_FAIL                              = "UPDATE_COMPANY_FAIL";
export const GET_COMPANY_START                                = "GET_COMPANY_START";
export const GET_COMPANY_SUCCESS                              = "GET_COMPANY_SUCCESS";
export const GET_COMPANY_FAIL                                 = "GET_COMPANY_FAIL";
export const GET_USERS_COMPANY_START                          = "GET_USERS_COMPANY_START";
export const GET_USERS_COMPANY_SUCCESS                        = "GET_USERS_COMPANY_SUCCESS";
export const GET_USERS_COMPANY_FAIL                           = "GET_USERS_COMPANY_FAIL";
export const REGISTER_COMPANY_USER_START                      = "REGISTER_COMPANY_USER_START";
export const REGISTER_COMPANY_USER_SUCCESS                    = "REGISTER_COMPANY_USER_SUCCESS";
export const REGISTER_COMPANY_USER_FAIL                       = "REGISTER_COMPANY_USER_FAIL";

//VACCINAZIONI
export const CREA_VACCINO_START                               = "CREA_VACCINO_START";
export const CREA_VACCINO_SUCCESS                             = "CREA_VACCINO_SUCCESS";
export const CREA_VACCINO_FAIL                                = "CREA_VACCINO_FAIL";

//LANGUAGES
export const CHANGE_LANG                                      = "CHANGE_LANG";

//FAQ
export const GENERATE_FAQ_START                               = "GENERATE_FAQ_START";
export const GENERATE_FAQ_SUCCESS                             = "GENERATE_FAQ_SUCCESS";
export const GENERATE_FAQ_FAIL                                = "GENERATE_FAQ_FAIL";
export const SEARCH_FAQ_START                                 = "SEARCH_FAQ_START";
export const SEARCH_FAQ_SUCCESS                               = "SEARCH_FAQ_SUCCESS";
export const SEARCH_FAQ_FAIL                                  = "SEARCH_FAQ_FAIL";
export const DELETE_FAQ_START                                 = "DELETE_FAQ_START";
export const DELETE_FAQ_SUCCESS                               = "DELETE_FAQ_SUCCESS";
export const DELETE_FAQ_FAIL                                  = "DELETE_FAQ_FAIL";
export const UPDATE_FAQ_START                                 = "UPDATE_FAQ_START";
export const UPDATE_FAQ_SUCCESS                               = "UPDATE_FAQ_SUCCESS";
export const UPDATE_FAQ_FAIL                                  = "UPDATE_FAQ_FAIL";

//TICKET
export const GENERATE_TICKET_START                            = "GENERATE_TICKET_START";
export const GENERATE_TICKET_SUCCESS                          = "GENERATE_TICKET_SUCCESS";
export const GENERATE_TICKET_FAIL                             = "GENERATE_TICKET_FAIL";
export const SEARCH_TICKET_START                              = "SEARCH_TICKET_START";
export const SEARCH_TICKET_SUCCESS                            = "SEARCH_TICKET_SUCCESS";
export const SEARCH_TICKET_FAIL                               = "SEARCH_TICKET_FAIL";
export const GET_TICKET_HISTORY_START                         = "GET_TICKET_HISTORY_START";
export const GET_TICKET_HISTORY_SUCCESS                       = "GET_TICKET_HISTORY_SUCCESS";
export const GET_TICKET_HISTORY_FAIL                          = "GET_TICKET_HISTORY_FAIL";
export const ADD_TICKET_HISTORY_START                         = "ADD_TICKET_HISTORY_START";
export const ADD_TICKET_HISTORY_SUCCESS                       = "ADD_TICKET_HISTORY_SUCCESS";
export const ADD_TICKET_HISTORY_FAIL                          = "ADD_TICKET_HISTORY_FAIL";
export const CLEAN_SEARCHED_TICKETS                           = "CLEAN_SEARCHED_TICKETS";
export const GET_ALL_INFO_START                               = "GET_ALL_INFO_START";
export const GET_ALL_INFO_SUCCESS                             = "GET_ALL_INFO_SUCCESS";
export const GET_ALL_INFO_FAIL                                = "GET_ALL_INFO_FAIL";

//SCUOLE
export const CREA_ISTITUTO_START                              = "CREA_ISTITUTO_START";
export const CREA_ISTITUTO_SUCCESS                            = "CREA_ISTITUTO_SUCCESS";
export const CREA_ISTITUTO_FAIL                               = "CREA_ISTITUTO_FAIL";
export const GET_ISTITUTO_START                               = "GET_ISTITUTO_START";
export const GET_ISTITUTO_SUCCESS                             = "GET_ISTITUTO_SUCCESS";
export const GET_ISTITUTO_FAIL                                = "GET_ISTITUTO_FAIL";
export const CREA_SEDE_START                                  = "CREA_SEDE_START";
export const CREA_SEDE_SUCCESS                                = "CREA_SEDE_SUCCESS";
export const CREA_SEDE_FAIL                                   = "CREA_SEDE_FAIL";
export const CREA_CLASSE_START                                = "CREA_CLASSE_START";
export const CREA_CLASSE_SUCCESS                              = "CREA_CLASSE_SUCCESS";
export const CREA_CLASSE_FAIL                                 = "CREA_CLASSE_FAIL";
export const CREA_ALUNNO_START                                = "CREA_ALUNNO_START";
export const CREA_ALUNNO_SUCCESS                              = "CREA_ALUNNO_SUCCESS";
export const CREA_ALUNNO_FAIL                                 = "CREA_ALUNNO_FAIL";
export const CREA_PERSONALE_START                             = "CREA_PERSONALE_START";
export const CREA_PERSONALE_SUCCESS                           = "CREA_PERSONALE_SUCCESS";
export const CREA_PERSONALE_FAIL                              = "CREA_PERSONALE_FAIL";

//ETS
export const GENERATE_ETS_START                               = "GENERATE_ETS_START";
export const GENERATE_ETS_SUCCESS                             = "GENERATE_ETS_SUCCESS";
export const GENERATE_ETS_FAIL                                = "GENERATE_ETS_FAIL";

//CHAT
export const NOTIFICATION_SSE                                 = "NOTIFICATION_SSE";
export const LAST_READ_CHAT                                   = "LAST_READ_CHAT";
